import React, { useState } from "react";
import PageHero from "@/components/PageHero";
import Section from "@/components/Section";
import { Building2, Stethoscope } from "lucide-react";
import ForHospitals from "@/pages/ForHospitals";
import ForPersonnel from "@/pages/ForPersonnel";

export default function Partner() {
  const [tab, setTab] = useState("hospital");
  return (
    <>
      <PageHero
        title="Partner with HomeCure"
        subtitle="Whether you run a hospital or are a healthcare professional — register your interest and we will reach out during onboarding."
      />

      <Section>
        <div className="flex justify-center gap-2 mb-6">
          <button
            onClick={() => setTab("hospital")}
            className={`px-5 py-3 rounded-lg font-semibold inline-flex items-center gap-2 transition ${tab === "hospital" ? "bg-[#3780E0] text-white" : "bg-[#E8F0FB] text-[#2563B3] hover:bg-[#C3D9F6]"}`}
            data-testid="partner-tab-hospital"
          >
            <Building2 className="w-4 h-4" /> I represent a hospital
          </button>
          <button
            onClick={() => setTab("personnel")}
            className={`px-5 py-3 rounded-lg font-semibold inline-flex items-center gap-2 transition ${tab === "personnel" ? "bg-[#3780E0] text-white" : "bg-[#E8F0FB] text-[#2563B3] hover:bg-[#C3D9F6]"}`}
            data-testid="partner-tab-personnel"
          >
            <Stethoscope className="w-4 h-4" /> I&apos;m a healthcare professional
          </button>
        </div>
      </Section>

      <div className="-mt-20">
        {tab === "hospital" ? <ForHospitals /> : <ForPersonnel />}
      </div>
    </>
  );
}
